import { requestWithToken } from '../utilities/request';
const path = '/api/private/output_csv_processings';

/**
 * リスト取得
 * @param param {object}
 */
const list = param => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/list`,
    params: param,
    isQuiet: true,
  });
};

/**
 * CSV抽出状況確認
 * @param param {object}
 */
const info = (id, param) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/${id}/output_csv_processing_condition`,
    params: param,
  });
};

/**
 * 登録
 * @param param {object}
 */
const create = param => {
  return requestWithToken({
    method: 'POST',
    url: path,
    data: param,
  });
};

/**
 * ダウンロード
 * output_csv_processingsテーブルのdownload_statusを2:実施済みに更新する
 * S3に保存されているCSVファイルのURLを一時トークン付きで返す
 * @param id output_csv_processings.id
 */
const process = id => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}/${id}/download_status_processed`,
    isQuiet: true,
  });
};

export const OutputCsvProcessingsService = {
  create,
  info,
  list,
  process,
};
export default OutputCsvProcessingsService;



// WEBPACK FOOTER //
// ./src/services/OutputCsvProcessings.js